var $22f457165ee6e1d0$exports = {};
$22f457165ee6e1d0$exports = {
    "alert": `Upozornenie`,
    "dismiss": `Zru\u{161}i\u{165}`
};


export {$22f457165ee6e1d0$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
